module.exports = __webpack_public_path__ + "static/img/6661_phase_function_Paper_PointsHejduk_Prediction.92c91cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6661_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YED0
// module chunks = 0